module.exports = __webpack_public_path__ + "img/star-muted.ae4f8e97.svg";